import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UrlService} from '../../services/url.service';
import {DirectoryService} from '../../services/directory.service';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'directory-archived-items-filter',
    templateUrl: './directory-archived-items-filter.component.html',
    styleUrls: ['./directory-archived-items-filter.component.scss']
})
export class DirectoryArchivedItemsFilterComponent implements OnInit, OnDestroy {
    showDropdown = false;
    private dataRequestSubscribtion;

    filterValues = {
        show_moved_out: null,
        role: {},
        group_id: {}
    };

    filterChanges = new Subject<{[key: string]: string|string[]}>();

    constructor(
        private urlService: UrlService,
        public directoryService: DirectoryService,
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.setFilterValues(this.route.snapshot.queryParams);

        this.dataRequestSubscribtion = this.directoryService.onDataSend.subscribe(() => {
            if(this.directoryService.currentTabId != 'residents') {
                this.urlService.queryParams['role'] = null;
                this.urlService.queryParams['group_id'] = null;
            }

            if(['residents', 'vehicles', 'pets'].indexOf(this.directoryService.currentTabId) == -1) {
                this.urlService.queryParams['show_moved_out'] = null;
            }
        });


        // Update query params on filter params changes
        this.filterChanges.pipe(debounceTime(1000)).subscribe(params => {
            this.urlService.queryParams = {...this.urlService.queryParams, ...params};
            this.urlService.setQueryParams(null, 1);
        });
    }

    /**
     * Emits event with filter params
     * on filter values changes
     */
    filterChanged() {
        const params = {};

        Object.keys(this.filterValues).forEach(paramName => {
            const value = this.filterValues[paramName];

            if(value && typeof value === 'object') {
                params[paramName] = Object.keys(value).filter(key => value[key]);
            } else if (value) {
                params[paramName] = value.toString();
            } else {
                params[paramName] = null;
            }
        });

        this.filterChanges.next(params);
    }

    /**
     * Updates filter values state
     * depends on query params
     *
     * @param queryParams
     */
    setFilterValues(queryParams) {
        Object.keys(this.filterValues).forEach(paramName => {
            if(queryParams.hasOwnProperty(paramName)) {
                if(this.filterValues[paramName] && typeof this.filterValues[paramName] === 'object') {
                    const value = Array.isArray(queryParams[paramName]) ? queryParams[paramName] : [queryParams[paramName]];
                    value.forEach( key => this.filterValues[paramName][key] = true);
                } else {
                    this.filterValues[paramName] = !!queryParams[paramName];
                }
            }
        });
    }

    ngOnDestroy() {
        this.dataRequestSubscribtion.unsubscribe();
    }

    @HostListener('document:click', ['$event.target'])
    hideDropdown(targetElement: HTMLElement): void {
        if (!targetElement.closest('directory-archived-items-filter')) this.showDropdown = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/directory-archived-items-filter/directory-archived-items-filter.component.ts